<section class="summary-container" aria-label="Checklist summary">
  <article class="first-row">
    <p class="percentage-completed" aria-live="polite">{{
      T.my_track.count_percentage_complete | translate: { count: percentageComplete | number: '1.0-0' }
    }}</p>
    <p class="count-completed">{{
      T.common.count_of_total_check_completed
        | translate: { count: completeCount, total: checklistItems.length }
    }}</p>
  </article>
  <article class="second-row" aria-hidden="true">
    <div class="progress-bar">
      <div class="current-progress" [style.width]="percentageComplete + '%'"></div>
    </div>
  </article>
  <article class="third-row" aria-hidden="true">
    <div class="left-side">
      <span class="tab incomplete-tab" *ngIf="incompleteCount">{{ T.common.count_incomplete | translate: { count: incompleteCount } }}</span>
      <span class="tab failed-or-poor-tab" *ngIf="failedOrPoorCount">
        {{ T.common.count_failed_slash_poor | translate: { count: failedOrPoorCount } }}
      </span>
      <span class="tab unsure-or-fair-tab" *ngIf="unsureOrFairCount">
        {{ T.common.count_unsure_slash_fair | translate: { count: unsureOrFairCount } }}
      </span>
    </div>
    <div class="right-side">
      <app-button-transparent
        *ngIf="showExpandBtn"
        icon="unfold_more"
        [text]="isExpandedAll ? (T.common.collapse_all | translate) : (T.common.expand_all | translate)"
        (clicked)="toggleExpandOption()"
      ></app-button-transparent>
    </div>
  </article>
</section>
